<section class="component-layer">
  <div class="title">Audit Logs</div>

  <!-- Filters -->
  <div
    class="filter-room-table d-flex justify-content-between align-items-start flex-wrap gap-3"
  >
    <div class="d-flex flex-wrap align-items-end gap-2">
      <div class="keyword-search">
        <p-iconfield iconPosition="left">
          <p-inputicon>
            <mat-icon>{{ commonService.getIcon("Search") }}</mat-icon>
          </p-inputicon>
          <input
            pInputText
            type="text"
            [(ngModel)]="filters.search"
            (ngModelChange)="onFilterChangeDebounced()"
            placeholder="Search in message"
            class="search-room-table table-filter"
          />
        </p-iconfield>
      </div>

      <div class="filter-group filter_status">
        <p-select
          [options]="actionOptions"
          [(ngModel)]="filters.action"
          optionLabel="label"
          optionValue="value"
          placeholder="Action"
          [showClear]="true"
          class="table-filter filter-select"
          (onChange)="onFilterChange()"
          [style]="{ height: '38px' }"
        />
      </div>
      <div class="filter-group">
        <p-select
          [options]="entityOptions"
          [(ngModel)]="filters.entity"
          optionLabel="label"
          optionValue="value"
          placeholder="Entity"
          [showClear]="true"
          class="table-filter filter-select"
          (onChange)="onFilterChange()"
          [style]="{ minWidth: '140px', height: '38px' }"
        />
      </div>
      @if (isAdminRoute) {
        <div class="filter-group">
          <p-select
            [options]="propertyOptions"
            [(ngModel)]="filters.propertyId"
            optionLabel="label"
            optionValue="value"
            placeholder="Property"
            [showClear]="true"
            class="table-filter filter-select"
            (onChange)="onFilterChange()"
            [style]="{ minWidth: '160px', height: '38px' }"
          />
        </div>
      }
      <div class="filter_checkin_date">
        <mat-icon class="filter_list_icon">{{
          commonService.getIcon("Calendar")
        }}</mat-icon>
        <p-datepicker
          [(ngModel)]="dateFrom"
          placeholder="Date from"
          [showClear]="true"
          [iconDisplay]="'input'"
          [showIcon]="true"
          dateFormat="yy-mm-dd"
          class="table-filter"
          (onSelect)="onDateFromSelect($event); onFilterChange()"
          (onClear)="onDateFromSelect(null); onFilterChange()"
        />
      </div>
      <div class="filter_checkin_date">
        <mat-icon class="filter_list_icon">{{
          commonService.getIcon("Calendar")
        }}</mat-icon>
        <p-datepicker
          [(ngModel)]="dateTo"
          placeholder="Date to"
          [showClear]="true"
          [iconDisplay]="'input'"
          [showIcon]="true"
          dateFormat="yy-mm-dd"
          class="table-filter"
          (onSelect)="onDateToSelect($event); onFilterChange()"
          (onClear)="onDateToSelect(null); onFilterChange()"
        />
      </div>
    </div>

    <div
      class="d-flex filter-reset align-items-center"
      (click)="clearFilters()"
    >
      <img
        src="/images/icons/rotate-clockwise.svg"
        alt="Reset"
        class="reset-icon"
      />
      <span class="reset-text">Reset Filter</span>
    </div>
  </div>

  <!-- Table -->
  <p-table
    #dt
    [value]="logs"
    [lazy]="true"
    [paginator]="true"
    [rows]="limit"
    [totalRecords]="total"
    [rowsPerPageOptions]="[10, 20, 50, 100]"
    [loading]="loading"
    [showCurrentPageReport]="true"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
    responsiveLayout="scroll"
    dataKey="id"
    class="compact-table audit-logs-table"
    (onLazyLoad)="onLazyLoad($event)"
  >
    <ng-template pTemplate="header">
      <tr>
        <th style="min-width: 160px">Time</th>
        <th style="min-width: 100px">Action</th>
        <th style="min-width: 100px">Entity</th>
        <th style="min-width: 100px">Actor</th>
        <th style="min-width: 320px">Message</th>
        <th style="min-width: 100px; text-align: right">Actions</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-log>
      <tr>
        <td>{{ DateFormatterIso.format(log?.createdAt) || "—" }}</td>
        <td>
          <span
            class="action-badge"
            [class]="'action-' + (log?.action || '').toLowerCase()"
            >{{ log?.action || "—" }}</span
          >
        </td>
        <td>{{ log?.entity || "—" }}</td>
        <td>
          <div class="actor-cell">
            <div class="actor-avatar">
              @if (getProfileImageUrl(log?.actor?.profileImg)) {
                <img
                  [src]="getProfileImageUrl(log.actor.profileImg)"
                  alt="Actor"
                  (error)="onAvatarError($event)"
                />
              }
              <span
                class="i-circle avatar-fallback"
                [style.display]="getProfileImageUrl(log?.actor?.profileImg) ? 'none' : 'inline-flex'"
                >{{ getNameInitial(log?.actor) }}</span>
            </div>
            <span class="actor-name">{{ getActorDisplay(log?.actor) }}</span>
          </div>
        </td>
        <td class="message-cell text-truncate" [title]="log?.message">
          {{ log?.message || "—" }}
        </td>
        <td style="text-align: right">
          <button
            mat-icon-button
            [matMenuTriggerFor]="actionMenu"
            class="more-vert-button"
            [class.menu-open]="actionMenuTrigger.menuOpen"
            #actionMenuTrigger="matMenuTrigger"
          >
            <mat-icon>{{ commonService.getIcon("Three_Dot") }}</mat-icon>
          </button>
          <mat-menu #actionMenu="matMenu" class="simple-menu">
            <button
              mat-menu-item
              (click)="goToDetails(log.entity, log.entityId)"
            >
              <mat-icon>visibility</mat-icon>
              <span>Details</span>
            </button>
          </mat-menu>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="7" class="text-center py-4">No audit logs found.</td>
      </tr>
    </ng-template>
    <ng-template pTemplate="loadingbody">
      <tr>
        <td colspan="7" class="text-center py-4">
          <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
        </td>
      </tr>
    </ng-template>
  </p-table>
</section>
